<script>
import { ref, watch, onMounted, onBeforeUnmount } from "vue";

export default {
  name: "AnimatedNumber",

  props: {
    value: {
      type: [String, Number],
      default: 0,
    },

    duration: {
      type: Number,
      default: 700,
    },
  },

  setup(props) {
    const number = ref(0);
    let rafId;

    const getTarget = (value) => Number(String(value).replace(/[^\d.-]/g, "")) || 0;
    const getPrefix = (value) => (String(value).startsWith("$") ? "$" : "");

    const prefix = ref(getPrefix(props.value));

    function animate(from, to) {
      cancelAnimationFrame(rafId);

      const start = performance.now();

      function update(now) {
        const progress = Math.min((now - start) / props.duration, 1);

        number.value = Math.floor(from + (to - from) * progress);

        if (progress < 1) {
          rafId = requestAnimationFrame(update);
        } else {
          number.value = to;
        }
      }

      rafId = requestAnimationFrame(update);
    }

    watch(
      () => props.value,
      (newValue, oldValue) => {
        prefix.value = getPrefix(newValue);
        animate(getTarget(oldValue), getTarget(newValue));
      }
    );

    onMounted(() => {
      prefix.value = getPrefix(props.value);
      animate(0, getTarget(props.value));
    });

    onBeforeUnmount(() => {
      cancelAnimationFrame(rafId);
    });

    return {
      number,
      prefix,
    };
  },
};
</script>

<template>
  <span>{{ prefix }}{{ number }}</span>
</template>
